"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllPortfolioCovenantLoanTapeMetadataParamsIterable = exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_DELIMITER = exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_SEPARATOR = exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_START_ANCHOR = exports.PortfolioCovenantResultIterable = void 0;
const Date_1 = require("./Date");
exports.PortfolioCovenantResultIterable = [
    'PASS',
    'FAIL',
    'LEVEL_1_FAIL',
    'LEVEL_2_FAIL',
    'LEVEL_3_FAIL',
    'LEVEL_4_FAIL',
    'LEVEL_5_FAIL',
    'LEVEL_6_FAIL',
    'LEVEL_7_FAIL',
    'LEVEL_8_FAIL',
    'LEVEL_9_FAIL',
    'LEVEL_10_FAIL',
];
exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_START_ANCHOR = '__';
exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_SEPARATOR = '.';
exports.PORTFOLIO_COVENANT_LOAN_TAPE_METADATA_PARAMS_KEY_VALUE_DELIMITER = '_';
exports.AllPortfolioCovenantLoanTapeMetadataParamsIterable = [
    ...Date_1.Reporting.AllReportingPeriodPropertiesIterable,
    'key',
    'responseProperty',
];
//# sourceMappingURL=PortfolioCovenant.js.map